<template>
    <van-sticky offset-top="0">
        <div style="position: relative; background-color: white">
            <Wp_search_model></Wp_search_model>
            <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0" @click="clickToSearchPage">

            </div>
        </div>
    </van-sticky>

</template>

<script>
    import Wp_search_model from "../custom/Wp_search_model";
    export default {
        name: "Wp_home_search_model",
        components: {Wp_search_model},

        props:{
            params: { type: Object },
            list: { type: Array },
        },

        watch:{
            params(newVal){
                console.log(newVal)
            }
        },

        methods:{
            clickToSearchPage(){
                let param_url = "";
                if(this.params){
                    param_url = this.params.url;
                }
                if(param_url){
                    this.$router.push('search_model_page?url=' + encodeURIComponent(param_url));
                }else{
                    this.$router.push('search_model_page');
                }
            }
        }
    }
</script>

<style scoped>

</style>